import type {
  GetProcessorQuery,
  GetProcessorQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_PROCESSOR: TypedDocumentNode<
  GetProcessorQuery,
  GetProcessorQueryVariables
> = gql`
  query GetProcessor($id: String!) {
    processor(id: $id) {
      id
      fileId
      createdAt
      updatedAt
      fileRefs {
        id
        sortOrder
        role
      }
    }
  }
`;
